// extracted by mini-css-extract-plugin
export var active = "_2c-9";
export var backButton = "_2c-8";
export var clone = "_2c-e";
export var collapseBar = "_2c-j";
export var collapseMode = "_2c-l";
export var collapsed = "_2c-n";
export var dragHandle = "_2c-c";
export var dropdownIcon = "_2c-g";
export var expanding = "_2c-m";
export var hidden = "_2c-w";
export var iconContainer = "_2c-p";
export var iconSwapper = "_2c-v";
export var navItem = "_2c-6";
export var navItemIcon = "_2c-f";
export var navProfile = "_2c-7";
export var notificationCountBadge = "_2c-i";
export var notificationDot = "_2c-q";
export var optionsContainer = "_2c-h";
export var primaryNav = "_2c-0";
export var primaryNavDivider = "_2c-u";
export var primaryNavResizeHandle = "_2c-2";
export var primaryNavResizing = "_2c-1";
export var primaryNavTabSection = "_2c-t";
export var primaryTab = "_2c-o";
export var primaryTabIconBox = "_2c-r";
export var secondaryNav = "_2c-3";
export var selected = "_2c-s";
export var settingsNav = "_2c-4";
export var settingsNavItems = "_2c-5";
export var show = "_2c-d";
export var sideNav = "_2c-k";
export var teamItem = "_2c-a";
export var userProfileItem = "_2c-b";